var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardProjectinformationProjectdeleteIcon = function SvgNewcsDashboardProjectinformationProjectdeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_projectinformation_projectdelete_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M85 479h14v14H85z",
    "data-name": "\\u77E9\\u5F62 714"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_projectinformation_projectdelete_icon_svg__a)",
    transform: "translate(-85 -479)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M89 493a2.2 2.2 0 0 1-2.2-2.2v-7.9h-1.2a.6.6 0 0 1-.6-.6.6.6 0 0 1 .6-.6h2.2v-.5A2.2 2.2 0 0 1 90 479h4a2.2 2.2 0 0 1 2.2 2.2v.5h2.2a.6.6 0 0 1 .6.6.6.6 0 0 1-.6.6h-1.2v7.9A2.2 2.2 0 0 1 95 493Zm-1-2.2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V483h-8Zm7-9.1v-.5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v.5Zm-2.1 7.2v-3a.6.6 0 0 1 .6-.6.6.6 0 0 1 .6.6v3a.6.6 0 0 1-.6.6.6.6 0 0 1-.6-.6m-3 0v-3a.6.6 0 0 1 .6-.6.6.6 0 0 1 .6.6v3a.6.6 0 0 1-.6.6.6.6 0 0 1-.6-.6",
    "data-name": "\\u8054\\u5408 91"
  }))));
};
export default SvgNewcsDashboardProjectinformationProjectdeleteIcon;